import { FC } from 'react';
import { StyleSheet, Text } from '@react-pdf/renderer';
import Typography from '../../../Pdf/components/Typography';
import Column from '../../../Pdf/components/Column';
import Row from '../../../Pdf/components/Row';
import theme from '../../../Pdf/components/theme';
import Divider from './Divider';

const styles = StyleSheet.create({
  pageCount: {
    fontFamily: 'MaisonNeue',
    fontSize: theme.spacing(theme.spacingSizes.xs),
    fontWeight: 400,
    color: theme.palette.grey[500],
  },
});

type Props = {
  pageNumber?: number;
  totalPages?: number;
};

const Footer: FC<Props> = ({ pageNumber, totalPages }) => {
  return (
    <Column style={{ gap: theme.spacing(theme.spacingSizes.xxs * 3) }}>
      <Divider />
      <Row spacing="sm" justify="space-between">
        <Typography variant="body2" color={theme.palette.grey[500]}>
          Powered by Further. For more information see www.joinfurther.com.
        </Typography>
        {pageNumber && totalPages ? (
          <Text
            render={({ subPageNumber }) =>
              `Page ${pageNumber + subPageNumber - 1} of ${totalPages}`
            }
            style={styles.pageCount}
            fixed
          />
        ) : null}
      </Row>
    </Column>
  );
};

export default Footer;
